import React, { useMemo } from 'react';
import { getCompareAssetCardData } from '../../util/AssetStatusCard.util';
import CompareAssetCardBarChart from '../CompareAssetCardBarChart';
import CompareAssetCardAccordion from '../CompareAssetCardAccordion';
import { useAppStateYearSettlementModalDataStore } from '../../../../common/store/AppStateStore.zustand';

const YearSettlementModal: React.FC = () => {
  const { yearSettlementModalData, setYearSettlementModalData } = useAppStateYearSettlementModalDataStore();

  // 모든 Hook들을 먼저 호출
  const compareAssetCardData = useMemo(() => {
    if (!yearSettlementModalData?.firstMonthReport || !yearSettlementModalData?.lastMonthReport) return;
    return getCompareAssetCardData(yearSettlementModalData.lastMonthReport, yearSettlementModalData.firstMonthReport);
  }, [yearSettlementModalData?.firstMonthReport, yearSettlementModalData?.lastMonthReport]);

  // 조건부 렌더링
  if (!yearSettlementModalData) return null;

  const { isOpen, onClose, firstMonthReport, lastMonthReport, year } = yearSettlementModalData;

  if (!firstMonthReport || !lastMonthReport || !year) return null;
  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b border-gray-200">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-bold text-gray-800">{year}년 결산</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>
          <p className="text-gray-600 mt-1">
            {firstMonthReport.yearMonth} ~ {lastMonthReport.yearMonth} 기간의 자산 변동 내역
          </p>
        </div>
        <div className="p-6">
          {!compareAssetCardData && (
            <div className="flex flex-col items-center justify-center h-64 bg-gray-50/50 rounded-lg p-6">
              <div className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mb-4">
                <i className="fas fa-wallet text-3xl text-green-300"></i>
              </div>
              <h4 className="text-lg font-medium text-gray-700 mb-2">비교 데이터가 없습니다</h4>
              <p className="text-sm text-gray-500 text-center max-w-sm">
                해당 연도의 첫 달과 마지막 달 데이터가 필요합니다
              </p>
            </div>
          )}
          {compareAssetCardData && (
            <>
              <div className="mb-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">연간 자산 변동 요약</h3>
                <CompareAssetCardBarChart {...compareAssetCardData} />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">상세 내역</h3>
                <CompareAssetCardAccordion {...compareAssetCardData} />
              </div>
            </>
          )}
        </div>
        <div className="p-6 border-t border-gray-200 flex justify-end">
          <button
            onClick={onClose}
            className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300 transition-all duration-200 !rounded-button"
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};

export default YearSettlementModal;